import React from "react";

// Função para formatar o valor para a moeda brasileira
const formatarMoeda = (valor) => {
  const numero = parseFloat(valor);
  if (isNaN(numero) || numero === 0) return '';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(numero);
};

// Função para determinar a vigência correta
const getVigencia = (etq) => {
  const precoPromo = parseFloat(etq.etq_precopromo);
  const precoApp = parseFloat(etq.etq_precoapp);

  if (precoPromo > 0 && (!precoApp || precoApp === 0)) {
    return `${etq.etq_iniciopromo} até ${etq.etq_fimpromo}`;
  }

  if (precoApp > 0) {
    return `${etq.etq_inicioapp} até ${etq.etq_fimapp}`;
  }

  return etq.etq_vigencia || '';
};

const EtiquetaCard = ({ etq, onDelete }) => {
  const preco = formatarMoeda(etq.etq_preco);
  const promocao = formatarMoeda(etq.etq_precopromo);
  const app = formatarMoeda(etq.etq_precoapp);
  const vigencia = getVigencia(etq);

  // Determina o preço principal a exibir
  let precoPrincipal = '';
  let precoRiscado = '';

  if (app) {
    precoPrincipal = app;
    if (promocao && promocao !== "0") precoRiscado = promocao;
    else if (preco) precoRiscado = preco;
  } else if (promocao) {
    precoPrincipal = promocao;
    if (preco) precoRiscado = preco;
  } else {
    precoPrincipal = preco;
  }

  return (
    <div className="col-12 col-sm-6 col-lg-4 mb-3">
      {/* Adicionado 'position-relative' para o botão absoluto se posicionar corretamente no card */}
      <div className="card h-100 shadow-sm d-flex flex-column position-relative">
        
        {/* Botão de Exclusão (Lixeira) no canto superior direito */}
        {onDelete && (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger position-absolute top-0 end-0 m-2 rounded-circle shadow-sm"
            style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10 }}
            onClick={() => onDelete(etq)} // <-- Passa o objeto inteiro aqui
            title="Remover da fila"
          >
            <i className="fas fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </button>
        )}

        <div className="card-body text-center">
          <img
            src={`https://cdn-cosmos.bluesoft.com.br/products/${etq.etq_ean}`}
            alt={etq.etq_descricao}
            className="img-fluid mb-2 d-block mx-auto"
            style={{ maxHeight: "150px", objectFit: "contain" }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png';
            }}
          />
          <h5 className="card-title fw-bold">{etq.etq_descricao}</h5>
          
          {(precoPrincipal || precoRiscado) && (
            <div className="d-flex justify-content-center align-items-center mb-1 gap-2">
              {precoRiscado && (
                <span className="text-decoration-line-through text-secondary">
                  {precoRiscado}
                </span>
              )}
              {precoPrincipal && <span className="fw-bold">{precoPrincipal}</span>}
            </div>
          )}

          {vigencia && (
            <small className="text-muted mt-2 d-block">
              Vigência: {vigencia}
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default EtiquetaCard;